import { ViewType } from '../../state/ViewTypeState';

export { layoutConfig } from '../LayoutSwitchButton/layoutConfig';
export const layoutOptions: ViewType[] = ['table', 'grid'];
